module.exports = __webpack_public_path__ + "img/qr_code assuraf.06a4e6fb.jpg";